'use strict';

(function(global) {

  /**
   * Действия над многостраничным документом.
   * (Масштабирование, прокрутка и печать документа)
   * TODO: Класс и все его методы нуждаются в рефакторинге вместе с классом ImageActions
   *
   * @since 5.7.0
   */
  class MultipageActions extends global.ImageActions {

    constructor(context) {
      super(context);
      this.postInit();
    }

    /**
     * @see Core.preview.BaseActions._initAttributes
     */
    _initAttributes(context) {
      super._initAttributes(context);
      this._data = context;
      this._pageCount = context.convertedObj ? context.convertedObj.pageCount : 1;
      this._pagesIterator = 2;
      this._jPageNumber = $('.page-number-field');
    }

    /**
     * Подгрузка стилей и изменение страницы для адаптации под прокрутку.
     * @function Core.preview.scrolling.init
     * @since 5.1.0.1523
     * @return {Core.preview.scrolling}
     */
    postInit() {
      log.info('PREVIEW', 'Preview frame loaded successfully');

      this.href = `${this._data.previewHandlerUrl}/${this._data.convertedObj.id}/{0}`;

      this.prepareFirstImage().done(scrolling => {
        scrolling
          .fillWithPlaceHolders()
          .attachToFrameScrolling()
          .loadNeighbors(1);
      });

      return this;
    }

    /**
     * Первая картинка грузится всегда, она опорная точка, с нее
     * снимаются все параметры. Её-же мы делаем похожей на все остальные.
     * @function Core.preview.scrolling.prepareFirstImage
     * @return {Deferred}
     * @since 5.1.0.1523
     */
    prepareFirstImage() {
      log.info('PREVIEW', 'Preparing first image');

      this._jImage = this._jFrameContents
        .find('img:first')
        .attr('id', 'page_1')
        .data('pagenumber', '1')
        .wrap('<div class="placeholder current primary">');

      this._width = this._jImage.prop('naturalWidth');
      this._height = this._jImage.prop('naturalHeight');
      this._jImage
        .parent('.placeholder')
        .width(this._width)
        .height(this._height);

      const d = $.Deferred();
      d.resolve(this);

      return d.promise();
    }

    /**
     * После загрузки фрейма наполняем его пустышками чтобы появилась
     * прокрутка необходимой высоты.
     * @function Core.preview.scrolling.fillWithPlaceHolders
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    fillWithPlaceHolders() {
      let page = {
        id: this._pagesIterator,
        width: this._width,
        height: this._height,
        src: '',
      };

      // Рендер будет выполняться один раз, установка номера страницу будет выполняться через jQuery
      WA.templates.render('components/previewPage.compile.html', page).done((html) => {
        const tmpHtml = $('<div></div>');
        while (this._pagesIterator <= this._pageCount) {
          const jPlaceHolder = $(html);
          const jImg = jPlaceHolder.children(':first');
          const pageNumber = this._pagesIterator;
          jPlaceHolder.attr('id', `placeholder_${pageNumber}`);
          jPlaceHolder.attr('data-pagenumber', pageNumber);
          jImg.attr('id', `page_${pageNumber}`);
          jImg.attr('data-pagenumber', pageNumber);
          tmpHtml.append(jPlaceHolder);
          this._pagesIterator++;
        }
        this._jFrameContents.find('body').append(tmpHtml.html());
      });

      this._jPlaceholder = this._jFrameContents.find('.placeholder');
      return this;
    }

    /**
     * При перематывании страниц находим текущую страницу.
     *
     * @function Core.preview.scrolling.attachToFrameScrolling
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    attachToFrameScrolling() {
      let scroller = $(this._jFrame.get(0).contentWindow);
      if (this._isIpad) {
        scroller = this._jFrame.parent();
      }
      scroller.on('scroll touchmove', () => {
        this.handleCurrentPage();
      });

      return this;
    }

    /**
     * Поиск и выделение текущей страницы.
     *
     * @function Core.preview.scrolling.handleCurrentPage
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    handleCurrentPage() {
      const jFrameParent = this._jFrame.parent('div');
      let documentElement, jPage;
      let areaRect = [
        jFrameParent.width() * 0.5,
        jFrameParent.height() * (1 / 3),
      ];
      if (this._isIpad) {
        documentElement = jFrameParent.find('#contentContainer').get(0).contentWindow.document;
        areaRect[1] += jFrameParent.scrollTop();
        jPage = $(documentElement.elementFromPoint(...areaRect));
      } else {
        documentElement = this._jFrame.get(0).contentWindow.document;
        jPage = $(documentElement.elementFromPoint(...areaRect));
      }
      
      this._jFrameContents.find('.placeholder').removeClass('current');
      jPage.parent('.placeholder').addClass('current');
      const id = jPage.data('pagenumber');

      if (id && !isNaN(id)) {
        this._jPageNumber.val(id);
        this.loadPage(id);
        this.loadNeighbors(id);
      }

      return this;
    }

    /**
     * Загрузка страницы и обработка загрузки.
     *
     * @function Core.preview.scrolling.loadPage
     * @param {number} pageNum номер страницы
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    loadPage(pageNum) {
      const jPage = this._jFrameContents.find(`#page_${pageNum}`);

      const bindOnLoad = () => {
        jPage.parent().addClass('placeholder_spinner');
        jPage.attr('src', this.getURLForPage(pageNum)).one('load', (event) => {
          $(event.target)
            .removeClass('invisible')
            .parent()
            .removeClass('placeholder_spinner');
        }).each((event) => {
          // Если картинка уже была загружена, она помещеатся в браузерный кэш,
          // и при следующем откртытии страницы событие load не вызывается.
          // Вызываем его принудительно здесь.
          if (event.complete) {
            $(event.target).load();
          }
        });
      };

      if (!jPage.attr('src')) {
        requestAnimationFrame(() => {
          bindOnLoad();
        });
      }
    }

    /**
     * У страницы при малом масштабе могут быть видимые соседи. Их тоже требуется
     * загрузить чтобы картина была полной.
     *
     * @function Core.preview.MultipageActions.loadNeighbors
     * @param {string|number} pageNum Номер страницы
     * @param {boolean} [rotate = false] Повернуть?
     * @param {'N'|'E'|'S'|'W'} [direction = ''] Направление поворота
     * @return {Core.preview.MultipageActions}
     * @since 5.1.0.1523
     */
    loadNeighbors(pageNum, rotate = false, direction = '') {
      pageNum = +pageNum;

      if (this._jImage.length && this._jImage.height()) {
        const neighborsCount = Math.ceil(this._containerSize.height / this._jImage.height() / 2);
        for (let i = pageNum; i <= pageNum + neighborsCount; i++) {
          this.loadPage(i);
        }
        if (rotate) {
          this._rotatePages(direction);
        }
      }

      return this;
    }

    /**
     * Получение url изображения по номеру страницы.
     *
     * @function Core.preview.scrolling.getURLForPage
     * @param {number} pageNum номер страницы
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    getURLForPage(pageNum) {
      return format(this.href, pageNum);
    }

    /**
     * Переход к указанной странице.
     *
     * @function Core.preview.scrolling.jumpToPage
     * @param {number} pageNum номер страницы
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    jumpToPage(pageNum) {
      if (pageNum > this._pageCount) {
        pageNum = this._pageCount;
      } else if (pageNum < 1) {
        pageNum = 1;
      }

      const offsetTop = this._jFrameContents.find('#page_' + pageNum).offset().top;
      if (this._isIpad) {
        this._jFrame.parent().scrollTop(offsetTop);
      } else {
        this._jFrameContents.scrollTop(this._jFrameContents.find('#page_' + pageNum).offset().top);
      }

      this._data.selectedObj.pageNumber = pageNum;
    }

    /**
     * Перейти на предыдущую страницу.
     *
     * @method goToPreviousPage
     */
    goToPreviousPage() {
      this.jumpToPage(this._data.selectedObj.pageNumber - 1);
    }

    /**
     * Перейти на следующую страницу.
     *
     * @method goToNextPage
     */
    goToNextPage() {
      this.jumpToPage(this._data.selectedObj.pageNumber + 1);
    }

    /**
     * @see Core.preview.BaseActions.setScale
     */
    setScale(key) {
      this._scaleKey = key;
      super.setScale(key);

      setTimeout(() => {
        this.handleCurrentPage();
      }, 0);

      return this;
    }

    /**
     * @see Core.preview.ImageActions._rotatePages
     */
    _rotatePages(direction) {
      this._direction = direction;
      this._jPlaceholder
        .removeClass('N E W S')
        .addClass(direction);

      // Применим отступы если страницы оказываются повёрнуты на π/2
      const shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
      if (shouldFlipHeightAndWidth) {
        const sizeDiff = this._width - this._height;
        const placeholderMargin = {
          top: sizeDiff / 2,
          bottom: sizeDiff + this._placeholderMargin,
        };
        this._jPlaceholder.css({
          'margin': `${placeholderMargin.top}px auto ${placeholderMargin.bottom}px`,
        });
      } else {
        this._jPlaceholder.css({ 'margin': '' });
      }

      this.setScale(this._scaleKey);
    }

    /**
     * @see BaseActions.printDocFromPreview
     */
    printDocFromPreview() {
      // изначально в предпросмотре подгружаются первые две страницы,
      // поэтому для не подгруженных проставим корректный класс и src
      const tmpWindow = window.open('', 'PRINT', '');
      const contentDoc = $('#contentContainer').get(0).contentDocument;

      const bodyNodesArr = $(contentDoc.body.childNodes).toArray();
      // у первой страницы есть нормальный src, который можно использовать
      const primaryImg = $(contentDoc).find('.previewImage').get(0);
      const imgSrc = primaryImg.src.replace(window.location.origin, '');
      const spinnerText = L("PREPEARING_DOC_FOR_PRINT");

      const pages = $('.placeholder', contentDoc).get();
      const initWidth = $('img', pages[0])[0].getAttribute('initWidth');
      const initHeight = $('img', pages[0])[0].getAttribute('initHeight');

      let allPages = [];
      let pageNum = 1;
      let pagesLoaded = 0;
      let customBody = '';

      pages.forEach((page) => {
        const images = $('img', page).get();
        images.forEach((img) => {
          let downloadingImage = new Image();
          downloadingImage.onload = function () {
            const me = this;
            // TODO: здесь надо получить размеры загруженной картинки и понять надо ли ее повернуть при формировании page
            // me.naturalWidth; me.naturalHeight;
            me.style = 'height: 100%; width: 100%; object-fit: contain; overflow: hidden;';
            allPages[me.id] = `<div style='page-break-after: always; height: 100%; width: 100%;'>${me.outerHTML}</div>`;
            pagesLoaded++;

            if (pagesLoaded === pages.length) {
              allPages.forEach((printPage) => {
                customBody += printPage;
              });
              
              const customHTML = `
                <html lang="ru">
                  <head>
                    <link rel="stylesheet" type="text/css" href="/css/preview_print.css" />
                    <link rel="stylesheet" type="text/css" href="/css/wait-page.css" />
                    <script type="text/javascript">
                      function scriptOnLoad(){
                        var spinnerDiv = document.getElementsByClassName('spinner-container')[0]; 
                        spinnerDiv.parentNode.removeChild(spinnerDiv); 
                        var pages = document.getElementsByTagName('img'); 
                        for (var i = 0; i < pages.length; i++) { 
                          pages[i].style.opacity = 1; 
                        }
                        window.print();
                        ${!this._isIpad && !WA.ENV.isAndroid() ? 'window.close();' : ''}
                      }
                    </script>
                  </head>
                  <body onload="scriptOnLoad(); ">
                    <div class="spinner-container">
                      <div class="spinner">
                        <img class="spinner__ring" src="../svg/WillNotBeBaked/pic-loading-ring.svg" alt="">
                        <img class="spinner__logo" src="../svg/WillNotBeBaked/pic-logo.svg" alt="">
                        <span class="spinner__text">&nbsp;${spinnerText}...</span> 
                      </div> 
                    </div>
                    ${customBody}
                  </body>
                </html>`;
              tmpWindow.document.write(customHTML);
              tmpWindow.document.close();
            }
          }
          downloadingImage.src = `${Core.preview.actions._data.previewHandlerUrl}/${Core.preview.actions._data.convertedObj.id}/${pageNum}`;
          downloadingImage.id = pageNum;
          pageNum++;
        });
      });
    }
  }

  global.MultipageActions = MultipageActions;

})(window.Core.preview);